// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'

const ErrorSimple = ({ error, idRoot }) => (
  error
    ? (
      <p
        className={'error-message'}
        id={`${idRoot}-error-message`}>
        {error}
      </p>
    ) : null
)

ErrorSimple.propTypes = {
  error: string,
  idRoot: string.isRequired,
}

export default ErrorSimple
